import React from "react";
import cx from "classnames";

import styles from "./stepper.module.scss";

export declare namespace Step {
  export type Props = React.HTMLAttributes<HTMLDivElement> & {
    hasHeight?: boolean;
  };
}

export const Step = React.forwardRef<HTMLDivElement, Step.Props>(
  ({ className, hasHeight, ...props }, ref) => (
    <div
      style={hasHeight ? { height: "auto" } : { height: 0 }}
      className={cx(styles.step, className)}
      ref={ref}
      {...props}
    />
  )
);
